import Segmented from './Segmented';
export default Segmented;
